import React, {Component} from 'react';
import SectionSliding from "../SectionSliding/SectionSliding";
import SectionInterest from "../SectionInterest/SectionInterest";
import SectionSocial from "../SectionSocial/SectionSocial";
import SectionTestimonial from "../SectionTestimonial/SectionTestimonial";
import Footer from "../Footer/Footer";

class App extends Component {
	render() {
		return (
			<div>
				<SectionSliding/>
				<SectionInterest/>
				<SectionTestimonial/>
				<SectionSocial/>
				<Footer/>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js